import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { transparentize } from 'polished';
import { withDesignTokens } from '@segment/matcha/useDesignTokens';
import * as views from './Badge.views';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export var BaseBadge = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var tokens = _ref.tokens,
      children = _ref.children,
      tag = _ref.tag,
      className = _ref.className,
      href = _ref.href;
  return _jsx(views.Badge, _objectSpread(_objectSpread({
    ref: ref,
    as: href ? "a" : tag || "span",
    className: className,
    href: href
  }, tokens), {}, {
    children: children
  }));
});
export var Badge = withDesignTokens(BaseBadge, function () {
  return {};
}, {
  light: function light(theme, props) {
    switch (props.variant) {
      case "filledBoysenberry":
        return {
          backgroundColor: theme.palette.brand.boysenberry[500],
          borderColor: "transparent",
          color: theme.palette.neutrals.white[100]
        };

      case "filledAcai":
        return {
          backgroundColor: theme.palette.brand.darkAcai[200],
          borderColor: "transparent",
          color: theme.palette.brand.darkAcai[500]
        };

      case "filledGreen":
        return {
          backgroundColor: theme.palette.brand.segmentGreen[100],
          borderColor: "transparent",
          color: theme.palette.brand.segmentGreen[500]
        };

      case "filledBlue":
        return {
          backgroundColor: theme.palette.twilio.blue[10],
          borderColor: "transparent",
          color: theme.palette.twilio.blue[60]
        };

      default:
        return {
          backgroundColor: "transparent",
          borderColor: theme.palette.brand.darkAcai[400],
          color: theme.palette.brand.darkAcai[500]
        };
    }
  },
  dark: function dark(theme, props) {
    switch (props.variant) {
      case "filledBoysenberry":
        return {
          backgroundColor: theme.palette.brand.boysenberry[500],
          borderColor: "transparent",
          color: theme.palette.neutrals.white[100]
        };

      case "filledAcai":
        return {
          backgroundColor: transparentize(0.9, theme.palette.neutrals.white[100]),
          borderColor: "transparent",
          color: theme.palette.neutrals.white[100]
        };

      case "filledGreen":
        return {
          backgroundColor: theme.palette.brand.segmentGreen[100],
          borderColor: "transparent",
          color: theme.palette.brand.segmentGreen[500]
        };

      case "filledBlue":
        return {
          backgroundColor: theme.palette.twilio.blue[10],
          borderColor: "transparent",
          color: theme.palette.twilio.blue[60]
        };

      default:
        return {
          color: theme.palette.neutrals.white[100],
          backgroundColor: "transparent",
          borderColor: theme.palette.neutrals.white[100]
        };
    }
  },
  twilioLight: function twilioLight(theme, props) {
    switch (props.variant) {
      case "filledBoysenberry":
        return {
          backgroundColor: theme.palette.twilio.boysenberry[60],
          borderColor: "transparent",
          color: theme.palette.neutrals.white[100]
        };

      case "filledAcai":
        return {
          backgroundColor: transparentize(0.9, theme.palette.neutrals.white[100]),
          borderColor: "transparent",
          color: theme.palette.neutrals.white[100]
        };

      case "filledGreen":
        return {
          backgroundColor: theme.palette.twilio.green[10],
          borderColor: "transparent",
          color: theme.palette.twilio.green[70]
        };

      case "filledBlue":
        return {
          backgroundColor: theme.palette.twilio.blue[10],
          borderColor: "transparent",
          color: theme.palette.twilio.blue[60]
        };

      default:
        return {
          color: theme.palette.twilio.gray[80],
          backgroundColor: "transparent",
          borderColor: theme.palette.twilio.gray[30]
        };
    }
  }
});